import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const MarkEmailUnread = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf18a'}</MuiIcon>
    );
}
